import twcn from "classnames" // this is named twcn to make tailwind intellisense work

const button = (
  style: "ghost" | "footer" | "primary" | "primary_footer" | "delete" | "cancel" = "ghost",
  skeleton?: boolean,
  small?: boolean
) => {
  const general = twcn(
    "inline-flex cursor-pointer items-center rounded-md text-sm font-medium shadow-sm disabled:pointer-events-none disabled:opacity-50",
    {
      "px-4 py-2": !small,
      "px-3 py-1.5": small,
    }
  )

  switch (style) {
    case "primary":
      return twcn(
        general,
        "border border-indigo-500 bg-indigo-500 text-white hover:border-indigo-600 hover:bg-indigo-600 focus:z-10 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50 dark:border-indigo-600 dark:bg-indigo-600 dark:hover:border-indigo-700 dark:hover:bg-indigo-700",
        { "skeleton skeleton-border": skeleton }
      )
    case "primary_footer":
      return twcn(
        general,
        "border border-indigo-500 bg-indigo-500 text-white hover:border-indigo-600 hover:bg-indigo-600 focus:z-10 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50 dark:border-indigo-700 dark:bg-indigo-700 dark:hover:bg-indigo-800",
        { "skeleton skeleton-border": skeleton }
      )
    case "footer":
      return twcn(
        general,
        "border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-gray-900 dark:bg-gray-800 dark:text-gray-300 dark:hover:border-gray-900 dark:hover:bg-gray-900 dark:focus:ring-indigo-800",
        { "skeleton skeleton-border": skeleton }
      )
    case "delete":
      return twcn(
        general,
        "border border-gray-300 bg-white text-red-600 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 dark:border-gray-900 dark:bg-gray-800 dark:text-gray-300 dark:hover:border-gray-900 dark:hover:bg-gray-900 dark:focus:ring-red-800",
        { "skeleton skeleton-border": skeleton }
      )
    case "cancel":
      return twcn(
        general,
        "border border-red-500 bg-transparent text-red-600 transition-all hover:bg-red-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2",
        { "skeleton skeleton-border": skeleton }
      )
    case "ghost":
    default:
      return twcn(
        general,
        "border border-gray-300 bg-white text-gray-700 transition-all hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-gray-700 dark:bg-black dark:text-gray-400 dark:hover:border-gray-200 dark:hover:text-gray-200 dark:focus:ring-gray-500",
        { "skeleton skeleton-border": skeleton }
      )
  }
}

const inputButton = () => {
  return twcn(
    "relative -ml-px inline-flex items-center space-x-2 rounded-r-md border border-gray-300 bg-gray-50 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 disabled:pointer-events-none disabled:text-opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700"
  )
}

const menuItems = (right?: boolean) => {
  return twcn(
    "absolute right-0 z-10 mt-2 w-72 origin-top-right divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:divide-gray-800 dark:border dark:border-gray-700 dark:bg-black",
    { "left-0 sm:left-auto": !right }
  )
}

const menuItemTitle = (active?: boolean) => {
  return twcn("relative flex cursor-pointer select-none flex-col p-4 text-sm", {
    "bg-indigo-500 text-white": active,
    "text-gray-900 dark:text-gray-300": !active,
  })
}

const menuItemHelp = (active?: boolean) => {
  return twcn("mt-2", {
    "text-indigo-200 dark:text-indigo-100": active,
    "text-gray-500 dark:text-gray-400": !active,
  })
}

const sidebarItem = (active?: boolean) => {
  return twcn(
    "group flex items-center rounded-md px-3 py-2 text-sm leading-6 hover:bg-gray-100 dark:hover:bg-gray-700",
    {
      "font-medium text-black dark:text-white": active,
      "text-gray-700 hover:text-black dark:text-gray-400 dark:hover:text-white": !active,
    }
  )
}

export default { button, inputButton, menuItems, menuItemTitle, menuItemHelp, sidebarItem }
